<style lang="scss" scoped>
@import "../css/sub.scss";
// @import 'node_modules/bootstrap/scss/bootstrap.scss';
// @import 'node_modules/bootstrap-vue/src/index.scss';
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 600px;
  height: 450;
  margin: 0px auto;
  // padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px;
}

.modal-default-button {
  float: right;
}

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.modal-header {
  display: flex;
  padding: 20px;
  outline: none;
  border-bottom: 1px solid;
}
.modal-heade-input {
  width: 100%;
}
.modal-heade-input:focus-visible {
  outline: none;
}
.modal-body-container span {
  margin-top: 3px;
  font-size: 13px;
  line-height: 19px;
  color: #008bd3;
}
.modal-body-container p {
  margin-top: 14px;
  line-height: 22px;
}
.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 20px;
}
.modal-footer {
  cursor: pointer;
}
.modal-container-center{
  position: relative;
}
.search-result{
  background: #ffffff;
  max-height: 200px;
  overflow-y: auto;
}
.search-result ul li {
  cursor: pointer;
  line-height: 1.5;
}
.search-icon {
  cursor: pointer;
}
.pagination-item{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 40px;
  gap: 10px;
}
.previous-item,.next-item{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: aliceblue;
}
.previous-item:disabled{
  background: red !important;
}
</style>

<template>
  <div v-show="show" class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-container-center">
          <div class="modal-header">
            <input
              v-model="address"
              class="modal-heade-input"
              placeholder="예) 판교역로 235, 분당 주공, 삼평동 681"
              @keyup.enter="onSearch"
            />
            <b-icon icon="search" class="search-icon"  @click="onSearch"></b-icon>
          </div>
        </div>
        <div class="modal-body">
          <b-spinner v-show="loading" label="Loading..."></b-spinner>
          <template v-if="!loading">
            <div v-if="suggestions.length" class="search-result">
              <ul>
                <li v-for="(addr, index) in suggestions" :key="index" @click="setAddress(addr)">
                  <b>{{ addr.ldCode }} {{ addr.mnnmSlno }}</b> {{ addr.roadcode && addr.roadmnnm && `(${addr.roadcode} ${addr.roadmnnm})`}}
                </li>
              </ul>
            </div>
            <template v-else>
              <div  class="model-body-header">
                <h3>Tip</h3>
                <span
                  >아래와 같은 조합으로 검색을 하시면 더욱 정확한 결과가
                  검색됩니다.</span
                >
              </div>
              <div class="modal-body-container">
                <p>도로명 + 건물번호</p>
                <span>예) 판교역로 235, 제주 첨단로 242</span>
              </div>
              <div class="modal-body-container">
                <p>지역명(동/리) + 번지</p>
                <span>예) 삼평동 681, 제주 영평동 2181</span>
              </div>
              <div class="modal-body-container">
                <p>지역명(동/리) + 건물명(아파트명)</p>
                <span>예) 분당 주공, 연수동 주공3차</span>
              </div>
              <div class="modal-body-container">
                <p>사서함명 + 번호</p>
                <span>예) 분당우체국사서함 1~100</span>
              </div>
            </template>
          </template>
        </div>
        <div v-if="suggestions.length" class="pagination-item">
          <div class="previous-item" @click="onSearchPrevious" :disabled="pages===1" ><b-icon icon="chevron-left" aria-hidden="true"></b-icon></div>
           <span>{{pageNum}}</span>
          <div :disabled="pageNum===pages" class="next-item" @click="onSearchNext"><b-icon icon="chevron-right" aria-hidden="true"></b-icon></div>
        </div>
        <div class="modal-footer">
          <span @click="closePopup"> close</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

// const pattern = /^([\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uAC00-\uD7AF\uD7B0-\uD7FF\s\d]*)((\s)(\uC0B0?)(\d*)(-?)(\d*))(.*)$/
// const regexKorean = /[\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uAC00-\uD7AF\uD7B0-\uD7FF]/g

export default {
  name: 'LandUsePopup',
  props: {
    show: { type: Boolean, default: () => false },
    value: { type: String, default: () => '' }
  },
  computed: {
    address: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  data () {
    return {
      suggestions: [],
      pageNext: 1,
      pages: 1,
      pageNum: 1,
      pageSize: 10,
      loading: false
    }
  },
  methods: {
    closePopup () {
      this.$emit('close')
    },
    splitData () {
      // const addressTrim = this.address.trim()
      // const index =  addressTrim.search(/[0-9]/)
      // if (index === -1) {
      //   return {'ld-code': addressTrim}
      // }
      // const kq1 = addressTrim.slice(index, addressTrim.length)
      // const kq2 = addressTrim.slice(0, index)

      // if (regexKorean.test(kq1)) {
      //   const lastIndex = addressTrim.lastIndexOf(' ')
      //   // console.log(lastIndex)
      //   if (lastIndex === -1) {
      //     return {'ld-code': addressTrim}
      //   }
      //   const kq3 = addressTrim.slice(lastIndex, addressTrim.length)
      //   const kq4 = addressTrim.slice(0, lastIndex)
      //   return {
      //     'ld-code': kq4,
      //     'mnnm-slno': kq3.trim()
      //   }
      // }
      // return {
      //   'ld-code': kq2,
      //   'mnnm-slno': kq1.trim()
      // }

      const addressTrim = this.address.trim()
      const index = addressTrim.search(/[0-9]/)
      if (index === -1) {
        return {'ld-code': addressTrim}
      }
      if (addressTrim[index + 1] === '가') {
        const kq2 = addressTrim.slice(index + 2, addressTrim.length)
        console.log(kq2)
        const kq1 = addressTrim.slice(0, index + 2)
        return {
          'ld-code': kq1.trim(),
          'mnnm-slno': kq2.trim()
        }
      }
      if (addressTrim[index - 1] === '산') {
        const kq2 = addressTrim.slice(index - 1, addressTrim.length)
        const kq1 = addressTrim.slice(0, index - 1)
        return {
          'ld-code': kq1,
          'mnnm-slno': kq2.trim()
        }
      }
      const kq2 = addressTrim.slice(index, addressTrim.length)
      const kq1 = addressTrim.slice(0, index)
      return {
        'ld-code': kq1,
        'mnnm-slno': kq2.trim()
      }
      // const result = pattern.exec(addressTrim)

      // if (!result) {
      //   return {
      //     'ld-code': addressTrim
      //   }
      // }
      // if (result[2].trim()) {
      //   return {
      //     'ld-code': result[1].trim(),
      //     'mnnm-slno': result[2].trim()
      //   }
      // } else {
      //   return {
      //     'ld-code': result[8].trim() ? `${result[1].trim()} ${result[8].trim()}` : result[1].trim()
      //   }
      // }
    },
    onSearch () {
      // console.log(this.splitData())
      this.loading = true
      axios.get('/api/landuse/suggest', { params: { ...this.splitData() } }).then(({ data }) => {
        this.suggestions = data.list
        this.pages = data.pages
        this.pageNum = data.pageNum
        this.pageNext = data.nextPage
        this.pageSize = data.size
      }).finally(() => (this.loading = false))
    },
    onSearchNext () {
      this.loading = true
      axios.get('/api/landuse/suggest', { params: { ...this.splitData(), page: this.pageNext, size: this.pageSize } }).then(({ data }) => {
        this.suggestions = data.list
        this.pageNum = data.pageNum
        this.pageNext = data.nextPage
      }).finally(() => (this.loading = false))
    },
    onSearchPrevious () {
      this.loading = true
      axios.get('/api/landuse/suggest', { params: { ...this.splitData(), page: this.pageNext - 2, size: this.pageSize } }).then(({ data }) => {
        this.suggestions = data.list
        this.pageNext = data.nextPage
        this.pageNum = data.pageNum
      }).finally(() => (this.loading = false))
    },
    setAddress (addr) {
      this.address = `${addr.ldCode} ${addr.mnnmSlno}`
      this.$emit('close', `${addr.ldCode} ${addr.mnnmSlno}`)
      this.closePopup()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LandUsePopup.vue